import { LightningElement, api } from "lwc";

class contentCollectionStencil extends LightningElement {
  @api count = null;
  @api variant = "brick";
  get stencilCount() {
    switch (typeof this.count) {
      case "number":
        return this.count;
      case "string":
        return parseInt(this.count, 10);
      default:
        return 3;
    }
  }
  get stencils() {
    return Array.from({
      length: this.stencilCount,
    }).map((_, i) => ({
      key: `stencil-${i}`,
    }));
  }
}

export default contentCollectionStencil;
